// import { InterceptorInstance as Interceptor } from "./data.service.js";
import { BaseService } from "./base.service.js";
import { createRequest, checkStatus } from "./utils.js";

class QueryService extends BaseService {
  sendRequest(url, options) {
    let promise = async function gettingRequest() {
      let request = await createRequest(url, options);
      return this.interceptor.fetch(request).catch((err) => {
        this._sendErrorToast(options, err);
        return Promise.reject(err);
      });
    };
    return promise.bind(this)();
  }

  fetch(url, options = {}) {
    const controller = new AbortController();
    options = Object.assign(
      { method: "GET", signal: controller.signal },
      options
    );

    const promise = async function gettingRequest() {
      const request = await createRequest(url, options);
      return fetch(request)
        .then(checkStatus)
        .catch((err) => {
          this._sendErrorToast(options, err);
          return Promise.reject(err);
        });
    };
    return promise.bind(this)();
  }
}

const QUERY_SERVICE_INSTANCE = new QueryService();
export { QUERY_SERVICE_INSTANCE as QueryService };

/**
 * Usage: queryService to be used in queryFn/mutateFn in react-query hooks
 *
 * Interface:
 *
 * const queryData = useQuery({
 *  queryKey: [...],
 *  queryFn: ({signal}) => QueryService.get("url", { data, signal })
 * })
 *
 */
